import { Helmet } from '@dr.pogodin/react-helmet';
import { useApiRead } from 'api-read-hook';
import { subDays } from 'date-fns';
import * as React from 'react';
import { useParams } from 'react-router-dom';

import {
  PageError,
  PageHeading,
  PageLoading,
  PageWrap,
} from '../../components';
import { useSelectedCompany } from '../../contexts/ClientDataContext';
import { Model } from '../../models';
import { formatAsDate } from '../../util';
import KpiFull from './KpiFull';
import RangeChoices from './RangeChoices';

export default function KpiPage() {
  const { companySlug, kpiSlug } = useParams<{
    companySlug: string;
    kpiSlug: string;
  }>();
  const selectedCompany = useSelectedCompany();

  const [fromDate, setFromDate] = React.useState(
    formatAsDate(subDays(new Date(), 30))
  );
  const [toDate, setToDate] = React.useState(formatAsDate(new Date()));

  const api = useApiRead<Record<string, Model.Kpi.View>>(
    `/company-data/${companySlug}/kpis/${kpiSlug}/${fromDate}/${toDate}`
  );

  if (api.error) return <PageError {...api} />;
  if (!api.data) return <PageLoading />;

  const kpi = api.data[kpiSlug!];

  return (
    <PageWrap>
      <Helmet>
        <title>{`${kpi.title} - KPI | ${selectedCompany.name}`}</title>
      </Helmet>
      <PageHeading
        right={
          <RangeChoices
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        }
      >
        {kpi.title}
      </PageHeading>
      <KpiFull kpi={kpi} />
    </PageWrap>
  );
}
